import React, { useMemo, useEffect, useState } from 'react';
import Pagination from '@mui/material/Pagination';
import { DataGrid, gridClasses } from '@mui/x-data-grid';
import 'features/dashboard/static/downtime/grid/grid.style.css';
import { isDarkMode } from 'app/utils/ColorContext';
import { useCommonInits } from 'hooks/useCommonInits';
import {
    getAssets,
    getGroups,
    getPriceRequest,
    getPriceByPage,
    getNotConfirmed,
} from 'redux/datasource/dataSourceSlice';
import { useSelector } from 'react-redux';
import { Typography, Button, Box, Paper } from '@mui/material';
import {
    getAllGroups,
    getUserDetail,
    getApcmGroup,
    deletePriceRequest,
    updateRequest,
    getRequestID,
    priceByPage,
    getRequestByGroupIds,
    getAllPriceRequests,
    getNoConfirmedData,
    getPriceReqRaisedDataByID,
} from 'redux/datasource/dataSourceActions';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { getForamttedDate } from 'utils/time';
import {
    getGroupsbyId,
    getRequestByID,
    getPanelValue,
    getPriceRequestById,
} from 'redux/datasource/dataSourceSlice';
import { updatePanelContent } from 'redux/panels/panelsSlice';
import { useParams } from 'react-router-dom';
import CreateEditRequestModal from './editRequest';
import CreateRequestModal from './createRequest';
import { AppConfirmDialog } from 'components/common/AppConfirmDialog';
import { BrowseHeader } from 'features/browse/browseHeader';
import { ROUTE_PATHS } from 'app/utils/route';
import { getUser, getUnitIds } from 'redux/auth/authSlice';

export const GroupID = panel => {
    const { id } = useParams();
    const { dispatch, select, navigate } = useCommonInits();
    const Assets = select(getAssets);
    const Groups = useSelector(getGroups);
    const user = select(getUser);
    const GroupByID = useSelector(getGroupsbyId);
    const [reqName, setReqName] = useState('');
    const [executedBy, setExecutedBy] = useState('');
    const [groupId, setGroupId] = useState('');
    const [groupName, setGroupName] = useState('');
    const [executed, setExecuted] = useState('');
    const [confirmed, setConfirmed] = useState('');
    const [newPrice, setNewPrice] = useState();
    const [oldPrice, setOldPrice] = useState();
    const [pageSize, setPageSize] = useState(10);
    const [showDialog, setShowDialog] = useState(false);
    const [openModal, setOpenModal] = useState(false);
    const [dateTime, setDateTime] = useState('');
    const [deleteData, setDeleteData] = useState({});
    const allRequest = useSelector(getPriceRequest);
    const getRequest = useSelector(getPriceRequestById);
    const request = useSelector(getPriceByPage);
    const requestById = useSelector(getRequestByID);
    const [openEditModal, setEditOpenModal] = useState(false);
    const [openConfirmModal, setOpenConfirmModal] = useState(false);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [reloadBox, setReloadBox] = useState(false);
    const [successMsg, setSuccessMsg] = useState(false);

    const notConfirmed = useSelector(getNotConfirmed);
    const units = useSelector(getUnitIds);
    const unitIds = JSON.parse(units);
    const filteredGroups = Groups?.filter(val => {
        return unitIds.find(a => {
            return val.name === a;
        });
    });

    useEffect(() => {
        dispatch(getAllPriceRequests());
    }, []);

    useEffect(() => {
        const params = {
            group_id: filteredGroups.map(group => group._id),
        };
        dispatch(getNoConfirmedData(params));
    }, [Groups]);

    const handleData = () => {
        const params = {
            group_id: filteredGroups.map(group => group._id),
        };
        dispatch(getNoConfirmedData(params));
    };

    useEffect(() => {
        if (id) {
            dispatch(getApcmGroup({ id }));
        }
    }, [id]);

    useEffect(() => {
        getRequestByPage();
    }, [page, pageSize, groupId]);

    // useEffect(() => {
    //     if (user) {
    //         dispatch(getUserDetail());
    //     }
    // }, []);

    const getData = () => {
        setTimeout(() => {
            const params = {
                group_id: filteredGroups.map(group => group._id),
            };
            dispatch(getNoConfirmedData(params));
            setSuccessMsg(false);
        }, 500);
    };
    useEffect(() => {
        // if (GroupByID) {
        const params = {
            group_id: id,
        };
        dispatch(getRequestByGroupIds(params));
        setGroupName(GroupByID?.name);
        setGroupId(GroupByID?._id);
        setExecutedBy(GroupByID?.created_by);
        // }
    }, [GroupByID]);

    const navigateTo = (path, params = {}) => {
        navigate(path, params);
    };

    useEffect(() => {
        if (Groups) {
            dispatch(getAllGroups());
        }
    }, []);

    useEffect(() => {
        if (requestById) {
            setReqName(requestById?.price_request_name);
            setOldPrice(requestById?.old_price);
            setDateTime(requestById?.date_time);
            setNewPrice(requestById?.price);
            setConfirmed(requestById?.confirmed);
            setGroupName(requestById?.group_name);
            setGroupId(requestById?.group_id);
        }
    }, [requestById]);

    useEffect(() => {
        setGroupId(GroupByID?._id);
        setGroupName(GroupByID?.name);
    }, []);

    const handleDataChange = () => {
        dispatch(
            updatePanelContent({
                groupName,
                groupId,
                reqName,
                oldPrice,
                newPrice,
                executed,
                executedBy,
                confirmed,
                dateTime,
            }),
        );
    };

    const selectGDelete = () => {
        const params = {
            _id: deleteData._id,
            group_id: deleteData.group_id,
            page_no: page,
            no_of_records: pageSize,
        };
        dispatch(deletePriceRequest(params));
        setShowDialog(false);
        getRequestByPage();
    };

    const selectRecord = data => {
        setEditOpenModal(true);
        const params = {
            _id: data?._id,
        };
        dispatch(getRequestID(params));
    };

    const selectConfirmRecord = data => {
        const params = {
            _id: data,
        };
        dispatch(getRequestID(params));
        setOpenConfirmModal(true);
        handleDataChange();
    };

    const handleDialog = data => {
        setShowDialog(true);
        setDeleteData(data);
    };

    const handleRequestModal = () => {
        setOpenModal(true);
    };

    const handleLiveAssets = () => {
        navigateTo(`/${ROUTE_PATHS.assetsLiveData}/${id}`);
    };

    const getRequestByPage = () => {
        const params = {
            page_no: page,
            no_of_records: pageSize,
            group_id: id || '',
        };
        dispatch(priceByPage(params));
    };

    const changePage = e => {
        setPage(e);
    };

    const changePageSize = e => {
        setPageSize(e, 10);
    };

    const handleSelection = () => {
        if (confirmed === 'N') {
            const params = {
                _id: requestById?._id,
                group_id: requestById?.group_id,
                group_name: groupName,
                price_request_name: reqName,
                old_price: oldPrice,
                price: newPrice,
                date_time: dateTime,
                confirmed: 'Y',
                executed: 'N',
                executed_by: '',
                page_no: page,
                no_of_records: pageSize,
            };
            dispatch(updateRequest(params));
            setOpenConfirmModal(false);
            handleDataChange();
            handleData();
            {
                GroupByID.length === 0 ? setSuccessMsg(true) : null;
            }
        } else {
            setOpenConfirmModal(false);
            setReloadBox(true);
        }
    };

    const renderConfirmDialog = () => (
        <AppConfirmDialog
            open={openConfirmModal}
            title="Request Confirmation"
            message="Are you sure you want to confirm this request?"
            confirmText="Yes"
            cancelText="Cancel"
            onConfirm={handleSelection}
            onCancel={() => setOpenConfirmModal(false)}
        />
    );

    const renderReloadBox = () => (
        <AppConfirmDialog
            open={reloadBox}
            title="Request"
            message="Price request already confirmed !"
            confirmText="OK"
            cancelText="Cancel"
            onConfirm={() => setReloadBox(false)}
            onCancel={() => setReloadBox(false)}
        />
    );

    const renderSuccessMsg = () => (
        <AppConfirmDialog
            open={successMsg}
            title="Request"
            message="Price request confirmed successfully !"
            confirmText="OK"
            cancelText="Cancel"
            onConfirm={() => getData()}
            onCancel={() => getData()}
        />
    );
    const renderDeleteDialog = () => (
        <AppConfirmDialog
            open={showDialog}
            title="Delete Confirmation"
            message="Are you sure you want to delete this group?"
            confirmText="Delete"
            cancelText="Cancel"
            onConfirm={selectGDelete}
            onCancel={() => setShowDialog(false)}
        />
    );

    const columns = useMemo(
        () => [
            {
                headerName: 'Confirm',
                field: '',
                width: 250,
                sortable: false,
                filterable: false,
                textAlign: 'center',
                editable: true,

                renderCell: params => {
                    return params.row.confirmed === 'N' ? (
                        <Button
                            variant="outlined"
                            style={{
                                backgroundColor: '#4CAF50',
                                width: '200px',
                            }}
                            onClick={() => selectConfirmRecord(params.row._id)}
                        >
                            Press to Confirm
                        </Button>
                    ) : (
                        <Button
                            variant="outlined"
                            style={{
                                backgroundColor: ' darkgray',
                                width: '200px',
                            }}
                        >
                            Sent for Execution
                        </Button>
                    );
                },
            },
            {
                field: 'date_time',
                headerName: 'Date Time For Execution',
                width: 250,
                sortable: false,
                filterable: false,
                textAlign: 'left',
            },
            {
                field: 'price_request_name',
                headerName: 'Price Request Name',
                width: 280,
                sortable: false,
                filterable: false,
                textAlign: 'left',
            },
            {
                field: 'old_price',
                headerName: 'Old Price',
                width: 150,
                sortable: false,
                filterable: false,
                textAlign: 'left',
            },
            {
                field: 'price',
                headerName: 'New Price',
                width: 150,
                sortable: false,
                filterable: false,
                textAlign: 'left',
            },
            {
                field: 'confirmed',
                headerName: 'Confirmed',
                width: 150,
                sortable: false,
                filterable: false,
                allowSorting: 'false',
                textAlign: 'left',
            },
            {
                field: 'action',
                headerName: 'Action',
                width: 150,
                sortable: false,
                filterable: false,
                editable: true,
                textAlign: 'center',
                renderCell: params => {
                    return (
                        <>
                            {params.row.confirmed === 'N' ? (
                                <Button
                                    style={{
                                        backgroundColor: 'transparent',
                                    }}
                                    onClick={() => selectRecord(params.row)}
                                >
                                    <EditIcon />
                                </Button>
                            ) : (
                                <Button disabled={true}>
                                    <EditIcon />
                                </Button>
                            )}
                            {params.row.confirmed === 'N' ? (
                                <Button
                                    style={{
                                        backgroundColor: 'transparent',
                                    }}
                                    onClick={() => handleDialog(params.row)}
                                >
                                    <DeleteIcon />
                                </Button>
                            ) : (
                                <Button disabled={true}>
                                    <DeleteIcon />
                                </Button>
                            )}
                        </>
                    );
                },
            },
        ],
        [],
    );

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = event => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(1);
    };
    const pagination = (
        <Pagination
            component="div"
            count={
                GroupByID.length === 0
                    ? notConfirmed?.length
                    : getRequest?.length
            }
            page={page}
            onPageChange={handleChangePage}
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={handleChangeRowsPerPage}
        />
    );
    return (
        <>
            <BrowseHeader />
            <Paper
                variant="outlined"
                sx={{
                    pl: 2,
                    padding: 1,
                    marginLeft: '8px',
                    marginRight: '8px',
                }}
            >
                <Box sx={{ padding: 1 }}>
                    <div
                        style={{
                            padding: 1,
                            display: 'flex',
                            justifyContent: 'space-between',
                        }}
                    >
                        {GroupByID.length !== 0 ? (
                            <Typography
                                variant={'h6'}
                                sx={{ marginLeft: '20px' }}
                            >
                                Group Name : {GroupByID?.name}
                            </Typography>
                        ) : (
                            ''
                        )}
                        <div>
                            {GroupByID.length !== 0 ? (
                                <Button
                                    variant={'outlined'}
                                    onClick={() => handleRequestModal()}
                                >
                                    Raise new Price Request
                                </Button>
                            ) : (
                                ''
                            )}
                            &nbsp;&nbsp;
                            <Button
                                variant={'outlined'}
                                onClick={() => handleLiveAssets()}
                            >
                                Station Status
                            </Button>
                        </div>
                    </div>
                </Box>
                {showDialog && renderDeleteDialog()}

                {successMsg && renderSuccessMsg()}

                {openModal && (
                    <CreateRequestModal
                        isOpen={openModal}
                        handleCloseModal={setOpenModal}
                        setSizePage={pageSize}
                        setPageNo={page}
                    />
                )}

                {openEditModal && (
                    <CreateEditRequestModal
                        Open={openEditModal}
                        handleEdited={selectRecord}
                        setSizePage={pageSize}
                        setPageNo={page}
                        handleCloseModal={setEditOpenModal}
                    />
                )}
                {openConfirmModal && renderConfirmDialog()}
                {reloadBox && renderReloadBox()}
            </Paper>
            <Box sx={{ height: '75%', width: '100%', padding: 1 }}>
                <Paper sx={{ width: '100%' }}>
                    <DataGrid
                        disableColumnMenu
                        rows={GroupByID.length === 0 ? notConfirmed : request}
                        columns={columns}
                        pagination
                        rowCount={
                            GroupByID.length === 0
                                ? notConfirmed?.length
                                : getRequest?.length
                        }
                        getRowId={row => row._id}
                        rowsPerPageOptions={[10, 25, 50]}
                        autoHeight={true}
                        page={page}
                        pageSize={pageSize}
                        paginationMode="server"
                        onPageChange={changePage}
                        onPageSizeChange={changePageSize}
                        getRowSpacing={params => ({
                            top: params.isFirstVisible ? 0 : 3,
                            bottom: params.isLastVisible ? 0 : 3,
                        })}
                        components={{ footer: pagination }}
                    />
                </Paper>
            </Box>
        </>
    );
};
